import { Quote } from "lucide-react";
import { profile } from "@/data/profile";

export const About = () => (
  <section className="section" id="about">
    <div className="container">
      <p className="eyebrow">01 · About</p>
      <div className="about-grid">
        <h2 className="section-title" data-testid="about-heading">
          A student with a mission bigger than a classroom.
        </h2>
        <div className="about-body">
          <p className="body-text" data-testid="about-text">{profile.about}</p>
          <blockquote className="motto" data-testid="about-motto">
            <Quote size={18} className="motto-icon" />
            {profile.motto}
          </blockquote>
        </div>
      </div>
      <div className="pillars" data-testid="about-pillars">
        <div className="pillar">
          <span className="pillar-num">I</span>
          <h3>Financial Literacy</h3>
          <p>Designing curricula that help Punjabi immigrant families build financial confidence in a new country.</p>
        </div>
        <div className="pillar">
          <span className="pillar-num">II</span>
          <h3>Education</h3>
          <p>Teaching math and English to hundreds of young learners, and helping Punjabi families find their footing through free workshops.</p>
        </div>
        <div className="pillar">
          <span className="pillar-num">III</span>
          <h3>Public Service</h3>
          <p>Working inside the Pennsylvania House of Representatives to connect constituents with the services they need.</p>
        </div>
      </div>
    </div>
  </section>
);
